module.exports = __webpack_public_path__ + "static/media/checkbox-not-checked.2db5ab8b.svg";